export default "__VITE_ASSET__c6987835__"